import TabList from '@mui/lab/TabList';
import { Checkbox, styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledChecbox = styled(Checkbox)`
  padding: 0;
  color: var(--primary);
`;

export const StyledImage = styled('img')`
  display: block;
  max-width: 100%;
`;

export const StyledTabList = styled(TabList)`
  border-bottom: 1px solid var(--grey200);
  min-height: auto;

  .MuiTab-root {
    padding: 4px 10px;
    min-width: 80px;
    min-height: auto;
    margin-bottom: 0;
    p {
      color: var(--grey400);
      text-transform: none;
    }
  }

  .MuiTabs-indicator {
    background-color: var(--primary);
  }

  .Mui-selected {
    p {
      color: var(--primary);
    }
  }
`;

export const subscriptionEnable = {
  padding: '0 20px 0 0',
  height: '100%',

  '&.is-not-valid': {
    opacity: '0.4',
    pointerEvents: 'none',
  },

  '@media (max-width: 1024px)': {
    padding: '0',
  },
};

export const noQrs = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '16px',
};

export const TableLoader = {
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  background: '#fafafa85',
};

export const tableHeadWrapper = {
  border: 'none',
  padding: '8px 20px',

  '@media (max-width: 768px)': {
    padding: '16px',
  },
};

export const cellWrapper = {
  display: 'flex',
  alignItems: 'center',
  padding: '17px 20px',
  border: 0,
  background: 'var(--white)',
  boxShadow: '0px 0px 20px 0px #0000000d',
  marginBottom: '8px',
  borderRadius: '16px',

  '@media (max-width: 1200px)': {
    padding: '16px',
  },

  '@media (max-width: 768px)': {
    position: 'relative',
    alignItems: 'flex-start',
  },
};

export const qrImage = {
  overflow: 'hidden',
  padding: '5px',
  width: '76px',
  height: '76px',
  border: '1px solid var(--grey200)',
  borderRadius: '12px',
  marginLeft: '20px',
  flexShrink: 0,

  '@media (max-width: 768px)': {
    marginLeft: '12px',
    marginRight: '12px',
    width: '60px',
    height: '60px',
  },
};

export const rigthWrapper = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '24px',
  width: '100%',

  '@media (max-width: 1200px)': {
    gap: '5px',
  },

  '@media (max-width: 768px)': {
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
};

export const descriptionWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  width: '100%',
  maxWidth: '176px',
  marginLeft: '12px',

  '@media (max-width: 768px)': {
    maxWidth: '100%',
    order: 0,
    marginLeft: '0',
  },
};

export const descriptionType = {
  color: 'var(--orange2)',
};

export const descriptionName = {
  wordBreak: 'break-word',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const descriptionDate = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: 'var(--grey400)',
};

export const folderLink = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  maxWidth: '190px',
  color: 'var(--primary)',

  svg: {
    flexShrink: 0,
  },

  span: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
};

export const folderName = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: 'var(--grey400)',
  maxWidth: '100%',
  wordBreak: 'break-all',

  svg: {
    flexShrink: 0,
  },
};

export const qrType = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  minWidth: '101px',
  color: 'var(--grey400)',

  '@media (max-width: 768px)': {
    order: 2,

    '&.is-dynamic-qr': {
      justifyContent: 'flex-start',
      width: '100%',
    },
  },
};

export const dynamicQrText = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',

  '@media (max-width: 768px)': {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: '8px',
  },
};

export const customTooltip = {
  fontWeight: '400',
  fontSize: '15px',
  padding: '8px 16px',
  background: '#313031',
  color: 'var(--white)',
  maxWidth: 'none;',
};

export const chip = {
  position: 'relative',
  minWidth: '101px',
  padding: '4px',
  height: 'auto',
  background: '#fff9d3',
};

export const helpIcon = {
  position: 'absolute',
  right: '-4px',
  top: '-4px',
  cursor: 'pointer',
};

export const status = {
  width: '111px',
  padding: '4px',
  height: 'auto',

  '&.paused-item': {
    fontWeight: '400',
    fontSize: '15px',
    textTransform: 'capitalize',
    color: 'var(--white)',
    background: 'var(--orange2)',
  },

  '&.draft-item': {
    fontWeight: '400',
    fontSize: '15px',
    color: COLORS.grey400,
    background: COLORS.grey500,
  },

  '&.scan-limit-item': {
    fontWeight: '400',
    fontSize: '15px',
    color: COLORS.white,
    background: COLORS.orange2,
  },

  '&.active-item': {
    fontWeight: '400',
    fontSize: '15px',
    textTransform: 'capitalize',
    color: 'var(--greenMain)',
    background: 'var(--green100)',
  },
};

export const Pagination = {
  justifyContent: 'center',
  display: 'flex',
};
